import { createRoot } from 'react-dom/client';

import { dom } from '../../../../browser';
import { OcTheme } from '../../../../theme';

import RootMeButton from '../components/RootMeButton';

function isRootMeLtiUrl(url: URL) {
  return (
    url.hostname === 'root-me.org' &&
    url.searchParams.get('action') === 'api_lti' &&
    url.searchParams.has('environment')
  );
}

export default function handleRootmeLinks(domContainer: HTMLElement) {
  const links = dom.nodeListToArray(domContainer.getElementsByTagName('a')) as HTMLAnchorElement[];

  const {
    dataset: { currentUserId, projectId, translations },
  } = domContainer;

  if (!links.length || !currentUserId || !projectId) {
    return null;
  }

  return links
    .map((linkElement) => [new URL(linkElement.href), linkElement] as [URL, HTMLAnchorElement])
    .filter(([, linkElement]) => isRootMeLtiUrl(new URL(linkElement.href)))
    .forEach(([url, linkElement], n) => {
      const env = url.searchParams.get('environment');
      const rootContainer = document.createElement('span');
      rootContainer.style.display = 'block';
      rootContainer.style.textAlign = 'center';
      rootContainer.style.padding = '16px 0';

      linkElement.parentNode?.replaceChild(rootContainer, linkElement);
      const root = createRoot(rootContainer);

      root.render(
        <OcTheme productionPrefix={`rootme_${projectId}_${n}`}>
          <RootMeButton
            userId={Number(currentUserId)}
            projectId={Number(projectId)}
            environment={Number(env)}
            translations={JSON.parse(translations || '{}')}
          >
            {linkElement.innerHTML}
          </RootMeButton>
        </OcTheme>
      );
    });
}
